// We only need to import the modules necessary for initial render
import CoreLayout from '../layouts/CoreLayout/CoreLayout'
import { getCurrentRouteFromStorage } from 'utilities/session-utils'

/*  Note: Instead of using JSX, we recommend using react-router
    PlainRoute objects to build route definitions.   */

export const createRoutes = (store) => ({
  path        : '/',
  component   : CoreLayout,
  indexRoute  :
  {
    onEnter: (nextState, replace) => getCurrentRouteFromStorage(nextState, replace)
  },
  /* Note: Llamada asincrona de las rutas */
  getChildRoutes (location, next) {
    require.ensure([], (require) => {
      next(null, [
        // Provide store for async reducers and middleware
        require('./Home').default(store),
        require('./NotFound').default(store),
      ]);
    });
  }
})

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js